import initSearchBar from "./components/search-bar/search-bar";
import initSearchMenu from "./components/search-menu/search-menu";

function initGallery() {
  initSearchBar();
  initSearchMenu();
}

export default initGallery;
